<template>
    <div class="otherList" :class="{'getMin': list.length <= 2}" v-if="list.length > 0">
        <h2><span></span>其他课程</h2>
        <ul>
            <li v-for="(item,index) in list" :key="index">
                <a href="javascript:;" @click="getPlay(index, item.id)">
                    <dl>
                        <dt>
                            <div class="video-image">
                                <img :src="item.poster" :alt="item.title">
                                <i class="icon i-live" v-if="$store.state.getCurrnet === item.id">播放中</i>
                                <i class="play el-icon-video-play" v-else></i>
                                <div class="play-time">{{item.videodurationstr}}</div>
                            </div>
                        </dt>
                        <dd>
                            <p>{{item.title}}</p>
                            <p>来源：{{item.source}}</p>
                            <p>首播：{{item.date_ymdhis}}</p>
                            <!-- <p>
                                <span>
                                    <i class="eye"></i>
                                    0
                                </span>
                                <span>
                                    <i class="star"></i>
                                    0
                                </span>
                                <span>
                                    <i class="like"></i>
                                    0
                                </span>
                            </p> -->
                        </dd>
                    </dl>
                </a>
            </li>
        </ul>
        <div class="live-bottom" v-if="list.length > 0"><span>已展示全部内容</span></div>    
    </div>
</template>

<script>
import jsonp from 'jsonp'

export default{
    name: 'OtherList',
    props:{
        list: Array
    },
    computed:{
        isShow(){
            return parseInt(this.$store.state.getCurrnet) === parseInt(this.currnet);
        }
    },
    data(){
        return{
            currnet: '',
            id: this.$route.params.id,
            sortid: this.$route.params.sortid    
        }    
    },
    created(){
        // jsonp(`https://v.gxnews.com.cn/?c=json&a=coursecontent&id=${this.id}`, {} , (err, data) => {
        //     if (err) {
        //         console.error(err.message);
        //     } else {
        //         jsonp(`https://v.gxnews.com.cn/?c=json&a=course_list&sortids=${data.courseinfo.sortid}&limit=100`, {} , (err, res) => {
        //             if (err) {
        //                 console.error(err.message);
        //             } else {
        //                 this.list = res.courselist.map(item => {
        //                     return{
        //                         id: item.articleid,
        //                         url: item.playurl,
        //                         author: item.author,
        //                         title: item.title,
        //                         poster: item.img,
        //                         source: item.source,
        //                         date_ymdhis: item.date_ymdhis,
        //                         videodurationstr: item.videodurationstr
        //                     }
        //                 });
        //             }
        //         })
        //     }
        // })    
    },
    methods:{
        getPlay(index, id){
            this.currnet = id;
            document.title = this.list[index].title;
            this.$store.state.getCurrnet = id;
            this.$emit('sendOther', this.list[index]);        
        }
    }
}
</script>

<style lang="less" scoped>
    .otherList{
        margin-top: 0.3rem;
        padding-bottom: 1.6rem;
        box-sizing: border-box;
        h2{
            font-size: 0.45rem;
            color: #333;
            font-weight: bold;
            margin-bottom: 0.2rem;
            padding: 0 0.3rem;
            span{
                display: inline-block;
                height: 0.6rem;
                width: 0.15rem;
                background: #3793f4;
                vertical-align: middle;
                margin-right: 0.25rem;
                border-radius: 0.2rem;
            }
        }
        li{
            padding: 0 0.3rem 0.25rem 0.3rem;
            border-bottom: 1px solid #ececec;
            margin-bottom: 0.3rem;
            &:nth-last-of-type(1){
                border-bottom: none;
                margin-bottom: 0;
            }
            a{
                display: block;
            }
            dl{
                display: flex;
            }
            dt{
                width: 40%;
                .video-image{
                    position: relative;
                }
                i{
                    color: #fff;
                    position: absolute;
                }
                .play{
                    font-size: 0.7rem;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    font-weight: bold;
                }
                img{
                    width: 100%;
                    border-radius: 0.15rem;
                }
                .play-time{
                    position: absolute;
                    right: 0.05rem;
                    bottom: 0.05rem;
                    border-radius: 0.25rem;
                    background: linear-gradient(to right, #70befd , #3a7eff);
                    color: #fff;
                    padding: 0 0.15rem;
                    font-size: 0.26rem;
                }
            }
            dd{
                flex: 1;
                padding-left: 0.3rem;
                p{
                    margin-bottom: 0.16rem;
                    font-size: 0.4rem;
                    color: #000;
                    &:nth-of-type(2){
                        font-size: 0.32rem;
                        color: #4b4a4a;
                    }
                    &:nth-of-type(3){
                        font-size: 0.32rem;
                        color: #7b7a7a;
                    }
                    span{
                        margin-right: 0.2rem;
                    }
                    i{
                        display: inline-block;
                        vertical-align: middle;
                    }
                    .eye{
                        width: 0.45rem;
                        height: 0.32rem;
                        background: url("../../../../assets/images/eye_icon.png") no-repeat;
                        background-size: 100%;    
                    }
                    .star{
                        width: 0.4rem;
                        height: 0.45rem;
                        background: url("../../../../assets/images/star_icon.png") no-repeat;
                        background-size: 100%;    
                    }
                    .like{
                        width: 0.4rem;
                        height: 0.42rem;
                        background: url("../../../../assets/images/like_icon.png") no-repeat;
                        background-size: 100%;    
                    }
                }
            }
        }
        .list-enter-active,
        .list-leave-active {
            transition: all 2s;
        }
        .list-enter,
        .list-leave-to {
            opacity: 0;
            transform: translateY(50px);
        }
    }
    .getMin{
        min-height: 13.2rem;
    }              
</style>   